<template>
  <div class="lg:px-0 md:px-0 px-4">
    <TestimonialDetailsPopup
      :isActive="isDetailsActive"
      :selectedTesimonial="selectedTesimonial"
      @close="toggleDetails"
    />
    <div class="relative">
      <img
        src="@/assets/images/line/Frame 1000002302.png"
        alt="lineimg"
        class="m-auto"
      />
      <div class="absolute bg-designGT mob-hidden">
        <img src="../../../assets/images/bg-des/bgdTG.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design-dots-tsm mob-hidden">
        <img src="../../../assets/images/Ellipse 12.svg" alt="bg-polygon" />
      </div>
    </div>
    <p
      class="title sm-fsize16 md:font-normal lg:font-normal font-bold lg:pb-8 md:pb-8 pb-4 lg:px-12 md:px-12"
    >
      Testimonials
    </p>
    <div
      class="example-3d mb-12"
      @mouseenter="mouseover"
      @mouseleave="mouseleave"
    >
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide
          class="sm-h-auto cursor-pointer"
          v-for="(item, index) in testimonals"
          :key="index"
        >
          <div class="w-full p-8 cust-bg" @click="toggleDetails(true, item)">
            <div class="">
              <!-- <img :src="item.quotesImgopen" alt="quotesimg" class="w-4 h-4" /> -->
              <p
                class="pt-2 clr777 font-normal fsize16px italic ellipsis-6 md-ellipsis-6"
              >
                <span class="text-0193a1 fsize25"> ❝</span>
                {{ item.text }}
                <span class="text-0193a1 fsize25"> ❞</span>
              </p>
              <!-- <img :src="item.quotesImgclose" alt="quotesimg" class="w-4 h-4" /> -->
              <div class="mx-auto text-center">
                <img
                  :src="item.userImg"
                  class="mt-6 rounded-full w-20 h-20 border-user mx-auto object-fill"
                  alt=""
                />
                <p class="pt-3 font-normal fsize14px text-black uppercase">
                  {{ item.name }}
                </p>
                <p class="text-sm pt-1 clr777 font-light">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-pagination cust-posi" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

import TestimonialDetailsPopup from "./TestimonialDetailsPopup";
export default {
  components: {
    swiper,
    swiperSlide,
    TestimonialDetailsPopup,
  },
  data() {
    return {
      selectedTesimonial: {},
      testimonals: [
        {
          id: "01",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "What caregiving really is? I have been a caregiver for 20 years and in all that time I have played many roles, seen a lot of things, experienced a lot of highs and lows and in spite of having all that experience I am no closer to this answer of what ultimately is caregiving about. Is it a duty or an obligation that you remind yourself constantly, with this attitude in mind that down the road I won’t be able to look at myself in the mirror if I do not do the right thing now? Is it something that you do in a positive mind and find the reward in the service itself? My experience with caregiving is that caregiving is a life altering experience for better and for worse. It takes a toll on you. It also changes you in some ways. Whoever you are you share common traits with others of your kind, for example- you learn to be a self reliant superhuman; you share feelings of guilt, anxiety, the need to be helpful. Caregiving is hard even if you are close to the person; irrespective of a good relationship or a bad relationship. What makes it harder on yourself is if you idealize caregiving and what makes you lonely is if you surround yourself with people who idealize it for you. I am referring to critics. Unfortunately there are people who feel entitled to point out mistakes in a caregiver's job. They sometimes take the caregiver for granted. Whatever I have said, there is nothing new about that. What was new for me is that I had to learn this simple fact after I started coming to the support group meeting- there were two reasons why I joined the meeting- 1) I wanted to feel normal, 2) I wanted resources that will better equip me for my current role. What do I mean by I want to feel normal? In my daily life I only have two reactions- one, is they see me as this selfless person, very noble and I am like okay thanks but I have a really crappy day and I am tired. And the other one are those who make me feel like I do not know my job and criticize me. Slowly over time I learned to be self-reliant but also I started to feel like one mini alien in my own huge world and when I joined this meeting I discovered that there are other aliens like me out there. To me these meetings were like my personal space to be myself. I never felt judged, I only felt accepted. And something should be said about the transformative power of acceptance. I was able to take stock of my life and came to a few realizations, like-I have to put myself first. And cliché as it may sound, surprisingly I actually became a better caregiver. At the support group meetings I do not always get my problems solved but I feel emotionally recharged and nourished. I would say never underestimate the power of a support group”",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/team/alisha.png"),
          name: "Alisha Advani",
          description: "Active Caregiver",
          html: `<p class="">“What caregiving really is? I have been a caregiver for 20 years and in all that time I have played many roles, seen a lot of things, experienced a lot of highs and lows and in spite of having all that experience I am no closer to this answer of what ultimately is caregiving about. Is it a duty or an obligation that you remind yourself constantly, with this attitude in mind that down the road I won’t be able to look at myself in the mirror if I do not do the right thing now? Is it something that you do in a positive mind and find the reward in the service itself? My experience with caregiving is that caregiving is a life altering experience for better and for worse. It takes a toll on you. It also changes you in some ways. Whoever you are you share common traits with others of your kind, for example- you learn to be a self reliant superhuman; you share feelings of guilt, anxiety, the need to be helpful. Caregiving is hard even if you are close to the person; irrespective of a good relationship or a bad relationship. What makes it harder on yourself is if you idealize caregiving and what makes you lonely is if you surround yourself with people who idealize it for you. I am referring to critics. Unfortunately there are people who feel entitled to point out mistakes in a caregiver's job. They sometimes take the caregiver for granted. Whatever I have said, there is nothing new about that. What was new for me is that I had to learn this simple fact after I started coming to the support group meeting- there were two reasons why I joined the meeting- 1) I wanted to feel normal, 2) I wanted resources that will better equip me for my current role. What do I mean by I want to feel normal? In my daily life I only have two reactions- one, is they see me as this selfless person, very noble and I am like okay thanks but I have a really crappy day and I am tired. And the other one are those who make me feel like I do not know my job and criticize me. Slowly over time I learned to be self-reliant but also I started to feel like one mini alien in my own huge world and when I joined this meeting I discovered that there are other aliens like me out there. To me these meetings were like my personal space to be myself. I never felt judged, I only felt accepted. And something should be said about the transformative power of acceptance. I was able to take stock of my life and came to a few realizations, like-I have to put myself first. And cliché as it may sound, surprisingly I actually became a better caregiver. At the support group meetings I do not always get my problems solved but I feel emotionally recharged and nourished. I would say never underestimate the power of a support group”</p>`,
        },
        {
          id: "02",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "“A caregiver’s life is very tough, they need to be very practical, learn a lot very quickly, use social media very effectively, get in touch with the ‘heroes’ who have experience and also solutions. Share challenges and take all the guidance possible and try alternate therapies as then you know that you have tried everything possible.”",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/PicturesSet/Testimonials/Srikanth Batni.jpg"),
          name: "Srikanth Batni",
          description: "Active Caregiver",
          html: `<p class="">“A caregiver’s life is very tough, they need to be very practical, learn a lot very quickly, use social media very effectively, get in touch with the ‘heroes’ who have experience and also solutions. Share challenges and take all the guidance possible and try alternate therapies as then you know that you have tried everything possible.”</p>`,
        },
      ],
      swiperOptions: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 2.2,
        spaceBetween: 170,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        roundLengths: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 3,
          slideShadows: true,
        },
        breakpoints: {
          1600: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          505: {
            slidesPerView: 1,
            spaceBetween: 55,
          },
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      isDetailsActive: false,
    };
  },
  computed: {
    async swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
    mouseover() {
      // console.log("sumit", this.swiper);
      this.swiper.autoplay.pause();
    },
    mouseleave() {
      // console.log("sir ji");
      this.swiper.autoplay.run();
    },
  },
};
</script>

<style lang="scss" scoped>
.example-3d {
  width: 100%;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 430px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    background-position: center;
    background-size: cover;
    color: white;
    border: 10px solid #e9ddfa;
    border-radius: 25px;
    background-color: white !important;
  }

  .swiper-pagination {
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: white;
    }
  }
}
.border-user {
  border: 4px solid #0193a1;
  border-radius: 100%;
}
// .cust-bullet > .swiper-pagination-bullet {
// }
.cust-bullet > .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.cust-bg .swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(146, 146, 146, 0.2)),
    to(rgba(0, 0, 0, 0))
  ) !important ;
  background-image: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: -o-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}
.cust-posi {
  position: initial !important;
  padding-top: 25px;
}
.testimonal-h650px {
  height: 650px;
  @media (max-width: 640px) {
    height: auto;
  }
}
.testimonal-h850px {
  height: 860px;
}
@media (max-width: 640px) {
  .sm-testimonal-h660px {
    height: 660px;
  }
}
</style>
